const addTrackingPixel = (url) => {
    new Image().src = url;
};
export { addTrackingPixel };
